<span *ngIf="isMinicart && shoppingCart?.itemsCount > 0" class="">
    {{shoppingCart?.itemsCount > 0?shoppingCart?.itemsCount:orderItemsCount}}
</span>
<div tabindex="0" class="template1 container px-0" (touchstart)="isMiniCartHover=true;touchStarted=true;"
    (touchend)="isMiniCartHover=false;miniCartMouseLeave();" (mouseover)="isMiniCartHover=true"
    (mouseleave)="isMiniCartHover=false">
    <!-- show boolean used to hide/show mini cart view on hover -->
    <!-- MINI CART VIEW ON HOVER OF HEADER -->
    <div class="mini-cart-block" [class.not-retail]="memberTitleId!==memberTitle.RETAIL" [class.slideInOut]="show"
        *ngIf="isMinicart" (mouseover)="isMiniCartHover=true"
        (mouseleave)="isMiniCartHover=false;miniCartMouseLeave();" id="slimscroll-minicart">
        <div class="" *ngIf="!shoppingCart || shoppingCart.items.length < 1">
            <p tabindex="0" class="mini-cart-block__message text-transform-none">
                {{'shoppingCart.Your Shopping Bag is empty' | translate | translateKey}}</p>
        </div>
        <div tabindex="0" rel="js-mini-cart-block" (touchmove)="miniCartTouchMove($event)"
            *ngIf="shoppingCart && shoppingCart.itemsCount>0" class="slim-scroll" [disableDirective]="isTouchDevice"
            #slimScrollDiv="slimScroll" slimScroll width="calc(100% + 10px)" size="3px" height="inherit"
            alwaysVisible="true" wheelStep="20">
            <!-- <div class="px-2 mx-0 mini-cart-row text-right">
                <span class="underline pointer text-capitalize" (click)="clearCart($event)">{{'shoppingcart.Cancel Order' | translate | translateKey }}</span>
            </div> -->
            <div class="minicart-cart-row" *ngFor="let item of shoppingCart?.items | reverse;let isLast=last;">
                <div class="text-right mini-cart-block__actions">
                    <button tabindex="0" aria-label="delete product from cart"
                        class="mini-cart-block__action pointer px-0" (keyup.enter)="showConfirmModal(item)"
                        (click)="showConfirmModal(item)">
                        <i class="fa fa-trash-o mini-cart-block__action--text-orange"></i>
                    </button>
                </div>
                <div class="row mx-0 mini-cart-row">
                    <div class="text-center" id="Item-{{item.productId}}">
                        <img class="img--mini-cart" err-img (click)="navigateToProductDetail(item)" tabindex="0"
                            role="img" (keyup.enter)="navigateToProductDetail(item)"
                            attr.aria-label="{{item.displayName}} product image" [src]="item.iconUrl"
                            alt="product Image">
                    </div>
                    <div class="mini-cart-block__content-section" (click)="navigateToProductDetail(item)">
                        <div class="mini-cart-block__content-section__product-name mb-1">{{item.displayName}}</div>
                        <div tabindex="0" class="mini-cart-block__content-section__product-quantity">
                            <label class="sr-only">{{'common.Quantity'|translate|translateKey}}</label>
                            <div class="row">
                                <span class="p-0">{{'common.Quantity' |translate|translateKey}}:</span>
                                <span class="p-0">{{item.quantity}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col px-0 text-right">
                        <div class="mini-cart-block__content-section__product-price"
                            [class.mb-1]="memberTitleId!==memberTitle.RETAIL">
                            <label class="sr-only">applicable price</label>
                            <span
                                *ngIf="displayPriceConfig.displayApplicablePrice">{{item.applicablePrice | currencyFormat:true:false }}</span>
                            <span
                                *ngIf="displayPriceConfig.displayComputedTaxInclusivePrice">{{item.computedTaxInclusivePrice | currencyFormat:true:false }}</span>
                        </div>
                        <div *ngIf="displayPriceConfig&&displayPriceConfig.displayStrikeoutPrice"
                            [ngStyle]="{'display': item.isLiterature ? 'none' : 'block' }"
                            class="mini-cart-block__content-section__product-precost">
                            <label class="sr-only">{{'common.Product retail price' |translate|translateKey}}</label>
                            <span
                                *ngIf="displayPriceConfig.displayRetailPrice||(displayPriceConfig.displayStrikeoutPrice&&!displayPriceConfig.displayBaseRetailPrice)">{{item.retailPrice | currencyFormat:true:false}}</span>
                            <span
                                *ngIf="displayPriceConfig.displayBaseRetailPrice">{{item.baseRetailPrice | currencyFormat:true:false}}</span>
                        </div>
                        <div tabindex="0" class="mini-cart-block__content-section__product-cc"
                            *ngIf="memberTitleId!==memberTitle.RETAIL">
                            <label class="sr-only">case credits</label>
                            <span class="count">{{item.CV | ccFormat}}</span>
                        </div>
                    </div>
                    <div [class.border-bottom-0]="isLast" class="col-12 mini-cart-block--border-bottom"></div>
                </div>
            </div>
        </div>

        <div class="row pt-3 text-uppercase mini-cart-block__sub-total"
            *ngIf="shoppingCart && shoppingCart.itemsCount>0">
            <div tabindex="0" attr.aria-label="{{'common.Sub Total' |translate|translateKey}}"
                class="col-5 px-0 text-left">{{'common.Sub Total' | translate | translateKey}}</div>
            <div tabindex="0" attr.aria-label="{{shoppingCart?.subTotal | currencyFormat }}"
                class="col-7 px-0 text-right">{{shoppingCart?.subTotal | currencyFormat }}</div>
        </div>
        <div class="row mt-1 text-uppercase"
            *ngIf="shoppingCart && shoppingCart.itemsCount>0 && memberTitleId!==memberTitle.RETAIL">
            <div tabindex="0" attr.aria-label="{{'common.Total CC' |translate|translateKey}}"
                class="col-5 px-0 text-left">{{'shoppingcart.Total CC' |translate|translateKey}}</div>
            <div tabindex="0" attr.aria-label="{{shoppingCart?.totalPoints | ccFormat:false }}"
                class="col-7 px-0 text-right">{{shoppingCart?.totalPoints |ccFormat }}</div>
        </div>

        <!-- <div *ngIf="shoppingCart && shoppingCart.itemsCount>0" class="mini-cart-block__price-section mt-2 text-left pl-4">
            <span tabindex="0" attr.aria-label="{{'common.Sub Total' |translate|translateKey}}" class="mini-cart-block__price-section__total">
        {{'common.Sub Total' |translate|translateKey}}</span>
            <span tabindex="0" attr.aria-label="{{shoppingCart?.subTotal | currencyFormat }}" class="mini-cart-block__price-section__amount ml-5">{{shoppingCart?.subTotal | currencyFormat }}</span>
        </div>
        <div class="mini-cart-block__price-section mt-2 text-left pl-4" *ngIf="shoppingCart && shoppingCart.itemsCount>0 && memberTitleId!==memberTitle.RETAIL">
            <span tabindex="0" attr.aria-label="{{'commmon.Total CC' |translate|translateKey}}" class="mini-cart-block__price-section__total">
        {{'commmon.Total CC' |translate|translateKey}}</span>
            <span tabindex="0" attr.aria-label="{{shoppingCart?.totalPoints | ccFormat }}" class="mini-cart-block__price-section__amount ml-5 pl-2">{{shoppingCart?.totalPoints | ccFormat }}</span>
        </div> -->
        <div *ngIf="shoppingCart && shoppingCart.itemsCount>0" class="text-center mini-cart-block__btn-section mt-3">
            <a tabindex="0" attr.aria-label="{{'minicart.View Shopping Bag' |translate|translateKey}}"
                (keyup.enter)="showCartOnHover=false;gotoShopCart()"
                class="btn col mini-cart-block__btn-section__common px-2 btn-primary d-block d-sm-inline-block"
                (click)="showCartOnHover=false;gotoShopCart()">{{'minicart.Continue' |translate|translateKey}}</a>
            <!-- <a tabindex="0" attr.aria-label="{{'minicart.Checkout' |translate|translateKey}}" (keyup.enter)="goToCheckout();showCartOnHover=false"
        class="btn col mini-cart-block__btn-section__common px-2 btn-primary d-block d-sm-inline-block" (click)="goToCheckout();showCartOnHover=false"
        (focusout)="miniCartBackdropClick($event)">{{'minicart.Checkout' |translate|translateKey}}</a> -->
        </div>
    </div>
    <!-- Delete product confirmation popup on mini cart-->
    <div>
        <div tabindex="0" attr.aria-label="{{'minicart.delete item confirmation popup' |translate|translateKey}}"
            [config]="{backdrop: '',ignoreBackdropClick:false}" tabindex="0" (onHidden)="showModalPopup(false, true)"
            bsModal #confirmModal="app-modal" class="modal fade bs-example modal--center">
            <div class="modal-dialog confirm-dialog">
                <div class="modal-content p-2 cart-section">
                    <div *ngIf="removeItem">
                        <div class="modal-header py-2">
                            <h5 role="heading" class="modal-prodname">{{itemToRemove?.displayName}}</h5>
                            <button tabOrder tabTo="miniDelModal-yes-js" tabFrom="miniDelModal-no-js" title="close"
                                class="close pointer" role="button" id="miniDelModal-js"
                                aria-label="close delete item confirmation popup" type="button" (click)="confirm(false)"
                                data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p role="heading" class="modal-title modal-warn" id="myModalLabel">
                                {{'shoppingcart.Are you sure you want to remove this item' | translate | translateKey}}?
                            </p>
                        </div>
                        <div class="modal-footer justify-content-center">
                            <button tabOrder tabTo="miniDelModal-no-js" tabFrom="miniDelModal-js" role="button"
                                aria-label="yes" type="button" (click)="confirm(true,itemToRemove.id)"
                                class="btn btn-primary "
                                id="miniDelModal-yes-js">{{'common.Yes' | translate | translateKey}}</button>
                            <button tabOrder tabTo="miniDelModal-js" tabFrom="miniDelModal-yes-js" role="button"
                                aria-label="no" type="button" (click)="confirm(false)" class="btn btn-secondary"
                                id="miniDelModal-no-js">{{'common.No' | translate | translateKey}}</button>
                        </div>
                    </div>
                    <div *ngIf="clearBag">
                        <div class="modal-header py-2">
                            <h5 tabindex="0" role="heading" class="modal-prodname">
                                {{'shoppingcart.Cancel Order' | translate | translateKey}}</h5>
                            <button tabOrder tabTo="miniDelModal-yes-js" tabFrom="miniDelAll-no-js" title="close"
                                class="close pointer" role="button" id="miniDelAll-js"
                                aria-label="close delete item confirmation popup" type="button" (click)="confirm(false)"
                                data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p tabindex="0" role="heading" class="modal-title modal-warn" id="myModalLabel">
                                {{'shoppingcart.Are you sure you want to cancel the order' | translate | translateKey}}?
                            </p>
                        </div>
                        <div class="modal-footer justify-content-center">
                            <button tabOrder tabTo="miniDelAll-no-js" tabFrom="miniDelModal-js" role="button"
                                aria-label="yes" type="button" (click)="confirmToRemoveCart(true)"
                                class="btn btn-primary "
                                id="miniDelModal-yes-js">{{'common.Yes' | translate | translateKey}}</button>
                            <button tabOrder tabTo="miniDelAll-js" tabFrom="miniDelModal-yes-js" role="button"
                                aria-label="no" type="button" (click)="confirmToRemoveCart(false)"
                                class="btn btn-secondary"
                                id="miniDelAll-no-js">{{'common.No' | translate | translateKey}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>